export * from './email-matcher';
export * from './hashtag-matcher';
export * from './matcher';
export * from './mention-matcher';
export * from './phone-matcher';
export * from './url-matcher';

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/autolinker/dist/es2015/matcher/index.js
// module id = 962
// module chunks = 0